import type { AuditEvent, Lifecycle, UsageLimit } from './api';

// Fase 25B: helpers PUROS de presentacion del control plane (separados de los componentes para probar).

export const LIFECYCLE_LABEL: Record<Lifecycle, string> = { ACTIVE: 'Activo', SUSPENDED: 'Suspendido', ARCHIVED: 'Archivado' };

export const AUDIT_LABEL: Record<string, string> = {
  BUSINESS_CREATED: 'Negocio creado',
  BUSINESS_LIFECYCLE_CHANGED: 'Cambio de estado',
  BUSINESS_PLAN_CHANGED: 'Cambio de plan',
};

// Identificador tecnico estable a partir de un nombre (minusculas, sin acentos, guiones).
export function slugify(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);
}

export function usageText(u: UsageLimit | null): string {
  if (!u) return '—';
  return u.unlimited ? `${u.used} / ∞` : `${u.used} / ${u.limit}`;
}

// Resumen legible de un evento de auditoria (nunca JSON crudo ni UUIDs como info principal).
export function auditSummary(e: AuditEvent): string {
  const m = e.metadata ?? {};
  if (e.action === 'BUSINESS_LIFECYCLE_CHANGED') {
    return `${LIFECYCLE_LABEL[String(m.from) as Lifecycle] ?? m.from} → ${LIFECYCLE_LABEL[String(m.to) as Lifecycle] ?? m.to}`;
  }
  if (e.action === 'BUSINESS_PLAN_CHANGED') return `${m.fromPlanCode ?? '—'} → ${m.toPlanCode ?? '—'}`;
  if (e.action === 'BUSINESS_CREATED') return `${m.name ?? ''}${m.planCode ? ` · plan ${m.planCode}` : ''}`.trim();
  return '';
}
